import { Component, OnInit, Input } from '@angular/core';
import { OrderItem } from 'src/app/class/OrderItem';

@Component({
  selector: 'app-order-out-of-stock-list',
  templateUrl: './order-out-of-stock-list.component.html',
  styleUrls: ['./order-out-of-stock-list.component.scss']
})
export class OrderOutOfStockListComponent implements OnInit {
  @Input()
  list: Array<OrderItem>;

  constructor() {}

  ngOnInit() {}
}
